import { json } from "stream/consumers";

import apiPayment from "./accountBalanceApi";
import {
  accountBalanceError,
  accountBalanceLoading,
  accountBalanceSuccess,
  balanceError,
  balanceLoading,
  balanceSuccess,
} from "./accountBalanceStateActions";

export function getAccountBalance(dispatch: any, customerAccountId: number) {
  dispatch(balanceLoading());
  apiPayment.getAccountBalance(customerAccountId).then(
    (balance: any) => {
      dispatch(balanceSuccess(balance));
    },
    function (error: any) {
      return dispatch(balanceError());
    }
  );
}
function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
export async function getCurrentAccountBalance(dispatch: any, customerAccountId: number) {
  dispatch(accountBalanceLoading());
  await sleep(4000);
  apiPayment.getCurrentAccountBalance(customerAccountId).then(
    (balance: any) => {
      dispatch(accountBalanceSuccess(balance.currentBalance));
    },
    function (error: any) {
      return dispatch(accountBalanceError());
    }
  );
}
